import React, { useState } from 'react'

import { Row, Col } from 'antd'
import get from 'lodash/get'
import maxBy from 'lodash/maxBy'
import round from 'lodash/round'
import styled from 'styled-components'

import colors from '../../../../../components/hocs/colors'
import CompanyLogo from '../../../../../components/media/CompanyLogo'
import { pickWithInitialState } from '../../../../../utils/data/utils'
import { EmployeeBreakdownBars } from '../../../GraduateExplorer/components/EmployeeBreakdownBars'
import PillList from '../../../GraduateExplorer/components/PillList'
import SkillsBars from '../../../GraduateOutcomes/components/SkillsBars'
import StatCountUpTE from '../../AuthenticatedLayout/components/ReportElements/StatCountUpTE'

import CandidateTabs from './CandidateTabs'

const ExpandButton = styled.button`
  background: none;
  border: none;
  color: #33628e;
  cursor: pointer;
  font: inherit;
  padding: 0 4px;
  text-decoration: underline;
`

const CompanyView = props => {
  const [descExpanded, setDescExpanded] = useState(false)
  const companyInfo = get(props, 'companyInfo', {})

  const {
    avgSalary,
    avgTenure,
    companyId,
    companySpecialties,
    description,
    employeeBreakdown,
    keywords,
    name,
    skills,
    skillsDetail,
    topAlumni,
    topRecruiters,
  } = pickWithInitialState(companyInfo, [
    ['avgSalary', 0],
    ['avgTenure', 2],
    ['companyId', ''],
    ['companySpecialties', []],
    ['description', ''],
    ['employeeBreakdown', []],
    ['keywords', []],
    ['name', ''],
    ['skills', []],
    ['skillsDetail', []],
    ['topAlumni', []],
    ['topRecruiters', []],
  ])

  const maxPopularity = get(maxBy(skillsDetail, 'popularity'), 'popularity', 0)
  const maxRelevancy = get(maxBy(skillsDetail, 'relevance'), 'relevance', 0)

  return (
    <>
      <div style={{ alignItems: 'center', display: 'flex' }}>
        <CompanyLogo size={60} id={companyId} />
        <div style={{ marginLeft: 16 }}>
          <h2 className="ant-card-meta-title">{name}</h2>
          <div>
            {descExpanded ? description : description.slice(0, 120)}
            {description.length > 120 && (
              <ExpandButton
                aria-expanded={descExpanded}
                aria-label={(descExpanded ? 'Collapse' : 'Expand') + ' description'}
                onClick={() => setDescExpanded(s => !s)}
              >
                {descExpanded ? 'Collapse' : 'Expand'}
              </ExpandButton>
            )}
          </div>
        </div>
      </div>

      <PillList color={colors.blue3} pills={companySpecialties} title="Products/Services" />
      <PillList color={colors.orangeAccessible} pills={skills} title="Skills" />
      <PillList color={colors.green1} pills={keywords} title="Keywords" />

      <Row>
        <h3 className="ant-card-meta-title" style={{ marginTop: 10 }}>
          Employee Breakdown
        </h3>
        <Col span={12}>
          <EmployeeBreakdownBars data={employeeBreakdown.slice(0, 5)} />
        </Col>

        <Col span={12} style={{ marginTop: 10, textAlign: 'center' }}>
          <Col span={24}>
            <StatCountUpTE
              fontSize={40}
              data={avgTenure}
              title="avg. tenure"
              suffix=" years"
              comment={undefined}
              textString={undefined}
              weight={undefined}
              titleStyle={{ color: colors.gray1 }}
            />
          </Col>

          <Col span={24} style={{ marginTop: 30 }}>
            <StatCountUpTE
              fontSize={40}
              data={avgSalary}
              title="avg. salary"
              prefix="$"
              color="green"
              suffix={undefined}
              comment={undefined}
              textString={undefined}
              weight={undefined}
              titleStyle={{ color: colors.gray1 }}
            />
          </Col>
        </Col>
      </Row>

      {topAlumni.length || topRecruiters.length ? (
        <CandidateTabs topAlumni={topAlumni} topRecruiters={topRecruiters} />
      ) : null}

      <Row>
        <h3 className="ant-card-meta-title">Top Skills</h3>
        <Row style={{ marginBottom: 4 }}>
          <Col md={6} />
          <Col md={6} style={{ color: colors.gray1, fontSize: 12, fontWeight: 600 }}>
            Popularity
          </Col>
          <Col md={6} style={{ color: colors.gray1, fontSize: 12, fontWeight: 600 }}>
            Relevancy
          </Col>
        </Row>
        {skillsDetail.map((skill, index) => (
          <SkillsBars
            key={`${get(skill, 'name')}${index}`}
            name={get(skill, 'name')}
            values={[
              {
                name: 'popularity',
                value: round((get(skill, 'popularity') * 100) / maxPopularity),
              },
              {
                name: 'relevancy',
                // normalize to 70, and add 30 as a minimum
                value: round((get(skill, 'relevance') * 70) / maxRelevancy) + 30,
              },
            ]}
          />
        ))}
      </Row>
    </>
  )
}

export default CompanyView
